import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { ShowHeader } from "@/common/components/ShowHeader";
import { useParams } from "react-router-dom";
import MaintenanceWorkflowSidebar from "./components/MaintenanceWorkflowSidebar";
import Tabs from "@/common/components/Tabs";
import MaintenanceDescription from "./components/tabs/MaintenanceDescription";
import { useMaintenanceWorkflow } from "../Create/hooks/useMaintenanceWorkflow";

const MaintenanceWorkflowsShow = () => {
  const { id } = useParams();

  const {
    data: workflow,
    isPending: workflowIsPending,
    error: workflowError = {} as any,
    refetch: refetchWorkflow,
  } = useMaintenanceWorkflow(id);

  return (
    <div>
      <ShowHeader
        goBack
        goBackProps={{
          fallback: `/maintenance-workflows`,
          searchLastRouteFromReference: `/maintenance-workflows/${id}`,
        }}
        isLoading={workflowIsPending}
        title="Processos de manutenção (OS)"
        subtitle="Processo de manutenção"
        titleClassName="text-md"
        className="text-white-400"
        subtitleClassName="text-nowrap font-medium"
      />

      <ErrorMessageWrapper
        statusCode={workflowError?.status}
        refetchFunction={refetchWorkflow}
        className="h-[calc(100vh-8rem)]"
      >
        <div className="flex gap-4">
          <MaintenanceWorkflowSidebar workflow={workflow} />

          <div className="flex-1">
            <Tabs
              tabsListClassName="w-full bg-transparent rounded-none"
              tabsTriggerClassName="h-8 w-full rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
              tabsContentClassName="mt-6"
              tabsList={[
                {
                  label: 'Descrição da manutenção',
                  value: '',
                  body: <MaintenanceDescription workflow={workflow} />,
                },
              ]}
            />
          </div>
        </div>
      </ErrorMessageWrapper>
    </div>
  );
}

export default MaintenanceWorkflowsShow;
